import { create } from 'zustand'
import {
  MissMatchModalState,
  ScannerActionModalsState,
} from './scannerActionModals.types'
import { devtools } from 'zustand/middleware'
import { MainIconFlowState } from 'common/types'

const initialState: ScannerActionModalsState = {
  assetMissMatchModal: {
    isOpen: false,
  },
  setAssetMissMatchModal: () => {},
  setAssetMissMatchModalOpen: () => Promise.resolve(),
}

export const useScannerActionModalsStore = create<ScannerActionModalsState>()(
  devtools((set, get) => {
    return {
      ...initialState,

      setAssetMissMatchModal: (missMatchModalState: MissMatchModalState) => {
        set({
          assetMissMatchModal: {
            ...missMatchModalState,
          },
        })
      },

      setAssetMissMatchModalOpen: (
        isOpen: boolean,
        assetType?: MainIconFlowState['assetTypeLabel'],
        productType?: MainIconFlowState['assetTypeLabel'] | null
      ): Promise<void> => {
        return new Promise((resolve) => {
          set((state) => ({
            assetMissMatchModal: {
              ...state.assetMissMatchModal,
              isOpen,
              assetType,
              productType,
              onConfirm: () => {
                set((state) => ({
                  assetMissMatchModal: {
                    ...state.assetMissMatchModal,
                    isOpen: false,
                  },
                }))
                resolve()
              },
              onCancel: () => {
                set((state) => ({
                  assetMissMatchModal: {
                    ...state.assetMissMatchModal,
                    isOpen: false,
                  },
                }))
                resolve()
              },
            },
          }))
        })
      },
    }
  })
)
